import Vue from 'vue'
import Router from 'vue-router'
import { plugin as functionApi } from 'vue-function-api'
import Multiselect from 'vue-multiselect'
import VueAutosuggest from 'vue-autosuggest'
import Vuelidate from 'vuelidate'
import Vue2Filters from 'vue2-filters'
import App from './App.vue'
import { router } from './router'
import store from './store'
import navigationGuards from './common/navigation-guards'
import parseError from './common/filters/error-codes'
import titleCase from './common/filters/title-case'
import upperCase from './common/filters/upper-case'
import money from './common/filters/money'
import ordinalNumber from './common/filters/ordinal-number'
import phoneNumber from './common/filters/phone-number'
import enums from './common/filters/enums'
import permission from './common/filters/permission'
import date from './common/filters/date'
import dateTime from './common/filters/date-time'
import plural from './common/filters/plural'
import VueTheMask from 'vue-the-mask'
import Notifications from 'vue-notification'
import VueNumeric from 'vue-numeric'
import PortalVue from 'portal-vue'
import vuescroll from 'vuescroll'
import vueScrollTo from 'vue-scrollto'
import VueHotkey from 'v-hotkey'

import ConfirmDialog from './common/dialogs/ConfirmDialog.vue'
import LoadingDialog from './common/dialogs/LoadingDialog.vue'
import SmartTable from 'vuejs-smart-table'
import velocity from 'velocity-animate'

import BootstrapVue from 'bootstrap-vue'
import ToggleButton from 'vue-js-toggle-button'
import VueTimepicker from 'vue2-timepicker/src/vue-timepicker.vue'
import VueClipboard from 'vue-clipboard2'
import safeGet from 'lodash.get'

import * as VueGoogleMaps from 'vue2-google-maps'
import { GOOGLE_MAPS_API_CHANNEL, GOOGLE_MAPS_API_KEY } from './common/constants'

Vue.component('multiselect', Multiselect)
Vue.component('confirm-dialog', ConfirmDialog)
Vue.component('loading-dialog', LoadingDialog)

Vue.config.productionTip = false

Vue.use(Router)
Vue.use(functionApi)
Vue.use(Vuelidate)
Vue.use(BootstrapVue)
Vue.use(PortalVue)
Vue.use(vuescroll)
Vue.use(SmartTable)
Vue.use(vueScrollTo)
Vue.use(VueHotkey)

Vue.use(Vue2Filters)
Vue.use(VueTheMask)
Vue.use(Notifications, { velocity })
Vue.use(VueNumeric)
Vue.use(ToggleButton)
Vue.use(VueTimepicker)
Vue.use(VueAutosuggest)

Vue.use(VueGoogleMaps, {
  load: {
    key: GOOGLE_MAPS_API_KEY,
    channel: GOOGLE_MAPS_API_CHANNEL,
    // Pin Maps API to v3.64: google.maps.drawing.DrawingManager (used by
    // GmapDrawingControls.vue) was removed in v3.65.3b. See TPOS-10303;
    // TPOS-10304 tracks the durable replacement so this pin can be removed.
    v: '3.64',
    libraries: 'drawing'
  }
})

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.filter('parseError', parseError)
Vue.filter('titleCase', titleCase)
Vue.filter('upperCase', upperCase)
Vue.filter('money', money)
Vue.filter('ordinalNumber', ordinalNumber)
Vue.filter('phoneNumber', phoneNumber)
Vue.filter('enums', enums)
Vue.filter('permission', permission)
Vue.filter('date', date)
Vue.filter('dateTime', dateTime)
Vue.filter('plural', plural)

navigationGuards(router)

Vue.mixin({
  data: () => ({
    safeGet
  })
})

// Stick it on a global for debugging
window.vue = new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
